export const CORRECTIVES = 'correctives';
